import React, { useState } from 'react';
import moment from 'moment';
import get from 'lodash/get';
import { useTranslation } from 'react-i18next';

import { FontAwesomeIcon as FA } from '@fortawesome/react-fontawesome';
import { faFileAlt } from '@fortawesome/free-regular-svg-icons/faFileAlt';

import _ from 'lodash';
import ListResource from './ListResource.jsx';
import BtnDayRangePicker from '../btns/BtnDayRangePicker.jsx';
import { env } from '../../config';
import {
  numToLetter,
  getLang,
} from '~/commons/helpers';
import { getAcadYears } from '../../helpers';

// const acadYears = getAcadYears();

const api = '/api/quiz/answers';

const ListAnswers = () => {
  const stage = env?.school?.stage;
  const [dateRange, setDateRange] = useState(null);
  const isAdmin = env?.user?.roles?.includes('admin');
  const { t, i18n: { language } } = useTranslation();
  const lang = language === 'en' ? 'en' : 'zhhk';
  // const [acadYear, setAcadYear] = useState(acadYears[0]);

  return (
    <ListResource
      {...{
        searchable: [
          { value: 'article', label: 'Article' },
          { value: 'createdBy.name', label: 'Name' },
          { value: 'createdBy.schoolClass.title', label: 'Class' },
          {
            value: 'createdBy.schoolClass.grade',
            label: 'Grade',
            options: Object.keys(env.grades)
              .filter((g) => {
                if (stage === 'p') return g <= 6;
                if (stage === 's') return g >= 7;

                return true;
              })
              .map((g) => ({
                value: g,
                label: env.grades[g][lang],
              })),
          },
          { value: 'createdBy.studentId', label: 'Class No.' },
          ...isAdmin ? [{
            value: 'school.title', label: 'School',
          }] : [],
          {
            value: 'assignment',
            label: '階段',
            options: [
              { value: '1', label: '1' },
              { value: '2', label: '2' },
              { value: '3', label: '3' },
            ],
          },
          { value: 'timeSpent', label: 'Time Spent' },
        ],
        api,
        sort: { createdAt: -1 },
        filter: {
          // ...(dateRange && { assignmentDate: dateRange }),
          // ...(acadYear && { acadYear }),
        },
        actions: {
          find: false,
          create: false,
          remove: false,
          fileExport: true,
          fileImport: isAdmin && {
            children: t('Edit Score'),
            api: 'api/quiz/answers/import',
          },
        },
        cols: [
          {
            key: 'createdBy.name.full.en',
            sortable: true,
            children: 'Name',
            getter: (v, r) => getLang(get(r, 'createdBy.name.full'), lang),
          },
          ...(env.user.roles.includes('admin') ? [
            {
              key: 'createdBy.school.title.zhhk',
              children: 'School',
              getter: (v, r) => getLang(get(r, 'createdBy.school.title'), lang),
            },
          ] : []),
          {
            key: 'lv',
            children: 'Group',
            sortable: true,
            getter: (v) => env.lvs[v]?.[lang],
          },
          // {
          //   key: 'acadYear',
          //   children: 'Year',
          //   getter: (v) => (`${v}/${v+1}`),
          //   sortable: true,
          // },
          {
            key: 'createdBy.schoolClass.grade',
            children: 'Grade',
            sortable: true,
            getter: (v) => env.grades?.[v]?.[lang] || '',
          },
          {
            key: 'createdBy.schoolClass.title',
            children: 'Class',
            sortable: true,
          },
          {
            key: 'createdBy.studentNo',
            children: 'Class No.',
            sortable: true,
            getter: (v, r) => r?.createdBy?.studentId,
          },
          // {
          //   key: 'assignmentDate',
          //   sortable: true,
          //   getter: (v) => moment(v).format('DD/MM/YYYY'),
          // },
          {
            key: 'assignment',
            children: '階段',
            sortable: true,
            getter: (v) => (v.key ? (v.key.split('_')[0] || '').replace('period', '') : ''),
          },
          {
            key: 'article.title',
            children: 'Article',
            sortable: true,
          },
          // {
          //   key: 'late',
          //   sortable: true,
          // },
          {
            key: 'score',
            children: 'Article Total Score',
            sortable: true,
          },
          {
            key: 'timeSpent',
            children: 'Time Spent',
            sortable: true,
            getter: (v) => {
              if (!v || v === 0) return '';
              const minutes = Math.floor(v / 60);
              const seconds = v % 60;
              return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
            },
          },
          // {
          //   key: 'extraReading',
          //   sortable: true,
          //   getter: (v) => v ? 10 : 0,
          // },
          ...([0, 1, 2, 3, 4].map((i) => ({
            key: `marked[${i}]`,
            children: `Q${i + 1}`,
            getter: (v) => {
              if (!v) return '';

              const {
                answered,
                answeredSeq = [],
                format = 'single-select',
                answeredText,
                answeredTextSeq,
              } = v;
              let a;
              console.log({ answeredTextSeq });
              if (format === 'single-select') {
                a = answered !== undefined ? (answeredText || numToLetter(answered, true)) : '';
              }
              if (format === 'multi-select') {
                // a = answeredSeq.sort()
                //   .map((s) => numToLetter(s, true))
                //   .join(', ');
                a = answeredTextSeq.join(', ');
              }
              if (format === 'ordering') {
                // a = answeredSeq.map((s) => numToLetter(s, true))
                //   .join(' > ');
                a = answeredTextSeq.join(' > ');
              }
              if (format === 'matching') {
                if (_.some(answeredSeq, (x) => _.isEmpty(x))) return '';
                // a = answeredSeq.map((s, k) => (
                //   s === undefined
                //     ? ''
                //     : `[${s+1},${numToLetter(k, true)}]`
                // ))
                //   .sort()
                //   .join(' ');
                a = answeredTextSeq.join(', ');
              }

              return (
                <span className="nobreak">
                  {(answered !== undefined || answeredSeq.length > 0) ? v.isCorrect ? a : `(${a})` : ''}
                </span>
              );
            },
          }))),
        ],
      }}
    >
      {/* {() => (
        <>
          {isAdmin && (
            <a
              className="btn btn-link"
              href="/api/quiz/answers/import-example"
            >
              <FA icon={faFileAlt} fixedWidth />
              &nbsp;
              {t('Edit Score Template')}
            </a>
          )}

          {isAdmin && (
            <select
              className="custom-select w-auto float-right ml-2"
              key={1}
              value={acadYear}
              onChange={(e) => setAcadYear(e.target.value)}
            >
              <option value="">{t('Year')}</option>
              {acadYears.map((v) => (
                <option key={v} value={v}>{v}</option>
              ))}
            </select>
          )}
          <BtnDayRangePicker
            className="float-right"
            value={dateRange}
            onChange={setDateRange}
            placeholder={t('Assignment Date')}
          />
        </>
      )} */}
    </ListResource>
  );
};

export default ListAnswers;
